import {Component, Input} from "@angular/core";

@Component({
    selector: "fhm-action-buttons",
    templateUrl: "./action-buttons.component.html",
    styleUrls: ["./action-buttons.component.scss"],
    standalone: false
})
export class ActionButtonsComponent {

    @Input() title: string = "fhm.common.button.actions";
}
